import { Flex, Text, useThemeValue } from "@gravity-ui/uikit";
import { useGravityDevice } from "src/hooks/useGravityDevice";

import { InSalesLogo, WooCommerceLogo } from "../Icons";
import { TextSection } from "../TextSection";
import { usePlatformsBlockTranslate } from "./hooks/usePlatformsBlockTranslate";
import css from "./PlatformsBlock.module.scss";

export const PlatformsBlock = () => {
  const { isMobile, deviceText } = useGravityDevice();
  const themeValue = useThemeValue();

  const { title, description, woocommerce, insales } =
    usePlatformsBlockTranslate();

  return (
    <Flex
      id="platforms"
      direction={"column"}
      width={"100%"}
      maxWidth={"1440px"}
      style={{
        paddingLeft: isMobile ? 30 : 50,
        paddingRight: isMobile ? 30 : 50,
        gap: 60,
      }}
    >
      <TextSection title={title} description={description} />
      <Flex justifyContent={"space-between"} wrap={"wrap"} gap={6}>
        <div className={css.PlatformCardWrapper}>
          <Flex direction={"column"} gap={6}>
            <WooCommerceLogo />
            <Text variant={deviceText.body}>{woocommerce}</Text>
          </Flex>
        </div>
        <div className={css.PlatformCardWrapper}>
          <Flex gap={6} direction={"column"}>
            <InSalesLogo color={themeValue === "dark" ? "white" : undefined} />
            <Text variant={deviceText.body}>{insales}</Text>
          </Flex>
        </div>
      </Flex>
    </Flex>
  );
};
